const configsys = {
  apiUrl: 'https://backend.blog.sally.cmpsrv.com/',
  routes: [
    //{ icon: 'mdi-monitor-dashboard', text: 'Dashboard', href:'/dashboard' },
    { icon: 'mdi-monitor-dashboard', text: 'Posts', href:'/posts' },
    //{ icon: 'mdi-cart', text: 'Zutaten', href:'/ingredients' },
    {
      icon: 'mdi-settings',
      text: 'Logout',
      href:'/'
    },
  ]
};
export default configsys;
